(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["shiftup-hero-media"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('shiftup-hero-media')) {
  customElements.define('shiftup-hero-media', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { passive: true, signal: this.controller.signal };
      const reset = () => this.querySelectorAll('.is-touch-zoom').forEach(panel => panel.classList.remove('is-touch-zoom'));
      this.addEventListener('pointerdown', event => {
        if (event.pointerType === 'mouse' || !event.isPrimary) return;
        reset();
        event.target.closest('.su-home-hero__panel')?.classList.add('is-touch-zoom');
      }, options);
      window.addEventListener('pointerup', reset, options);
      window.addEventListener('pointercancel', reset, options);
      window.addEventListener('blur', reset, options);
      this.addEventListener('pointerleave', reset, options);
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}
  } catch(e) { console.error(e); }
})();

})();
